import styled from '@emotion/styled';

export const ChoicesContainer = styled.div`
  display: grid;
  align-items: stretch;
  margin: 10px 0;
  padding: 0 11px;
  gap: 10px 6px;
  grid-template-columns: repeat(auto-fit, minmax(calc(50% - 3px), 1fr));
  grid-auto-rows: auto;

  ${({ theme }) => theme.singleChoice};
`;

export const ChoiceButton = styled.button`
  padding: 10px 18px;
  line-height: 118%;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.01em;
  cursor: pointer;
  border: 1px solid;
  border-radius: 95px;
  transition: all 0.2s ease;

  ${({ theme }) => theme.singleChoiceButton};

  &:hover {
    border: 1px solid;
  }

  &:active {
    border: 1px solid;
  }
`;
